import React, { useEffect } from 'react';
import {
  Field,
  SitecoreContext,
  WithSitecoreContextProps,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import Helmet from 'react-helmet';
const htmlToReact = require('html-to-react');
const { Parser } = htmlToReact;
import InnerHTML from 'dangerously-set-html-content';

type CodeInjectionProps = WithSitecoreContextProps & {
  sitecoreContext: SitecoreContext & {
    pageEditing: boolean;
    route: {
      fields: {
        'Header Code': Field<string>;
        'Footer Code': Field<string>;
      };
    };
    custom: {
      siteConfiguration: {
        headerCode: string;
        footerCode: string;
      };
      targetHostName: string;
    };
  };
};

const CodeInjection = ({ sitecoreContext }: CodeInjectionProps): React.JSX.Element => {
  // Control should not render if page is in editing mode
  if (!sitecoreContext || sitecoreContext.pageEditing) {
    return <div className="codeInjection"></div>;
  }

  const parser = new Parser();

  const pageHeadInjection = sitecoreContext?.route?.fields['Header Code']?.value;
  const siteHeadInjection = sitecoreContext?.custom?.siteConfiguration?.headerCode;

  const pageFooterInjection = sitecoreContext?.route?.fields['Footer Code']?.value;
  const siteFooterInjection = sitecoreContext?.custom?.siteConfiguration?.footerCode;

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (!window.dataLayer) {
      window.dataLayer = [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-WFRRMQ3';

      document.head.appendChild(script);
    }
  }, []);

  return (
    <>
      <Helmet>
        {typeof siteHeadInjection === 'string' && siteHeadInjection.length > 0
          ? parser.parse(siteHeadInjection)
          : null}
        {typeof pageHeadInjection === 'string' && pageHeadInjection.length > 0
          ? parser.parse(pageHeadInjection)
          : null}
      </Helmet>

      {typeof siteFooterInjection === 'string' && siteFooterInjection.length > 0 && (
        <InnerHTML html={siteFooterInjection} />
      )}

      {typeof pageFooterInjection === 'string' && pageFooterInjection.length > 0 && (
        <InnerHTML html={pageFooterInjection} />
      )}
    </>
  );
};

export default withSitecoreContext()(CodeInjection);
